var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"video-editor",attrs:{"src":"https://video.useagencyai.com","allow":"camera; microphone; fullscreen; display-capture; autoplay; clipboard-read; clipboard-write"}})
}
var staticRenderFns = []

export { render, staticRenderFns }